
export const getBonus = (items) => {
        let marketing = 0;
        let kwotaDoObliczenia = 0;
        let sum = 0;
        let forOneLicenseForVendor = 0;
        let bonusPercent = 10;
        const groupSize = 2; 
let kwotaprowizji = 0;
let extra = 0
      for (let i = 0; i < items.length; i += groupSize) {
  // Sprawdź, czy mamy pełną grupę
  if (i + groupSize <= items.length) {
    const group = items.slice(i, i + groupSize);
    const groupSum = group.reduce((acc, r) => acc + Number(r.price || 0), 0);
    sum += groupSum;
 // licz marketing indywidualnie wg percent
      const groupBonus = group.reduce((acc, r) => {
        const price = Number(r.price || 0);
        const percent = Number(r.percentMarketing || r.percent || 0);
        return acc + (price * percent) / 100;
      }, 0);

      extra += groupBonus;
  //  console.log(`Grupa ${i / groupSize + 1}:`, group.map(r => r.price), 'suma =', groupSum);
  }
}

      

// iterujemy po wszystkich licencjach
        items.forEach((lic, i) => {
        //  bonusPercent = lic.percentMarketing || 0;
        forOneLicenseForVendor = lic.percentProvision || 0;
          const price = Number(lic.price) || 0;
          kwotaDoObliczenia += price;
      
       //   extra+=price*bonusPercent/100;

          kwotaprowizji+=price*forOneLicenseForVendor/100;
          // co drugą licencję nalicz procent od sumy dotychczasowych licencji (bez bieżącej)



});

//extra = (sum * bonusPercent) / 100;

 //kwotaprowizji = (forOneLicenseForVendor * kwotaDoObliczenia)/ 100;
marketing = extra;

return [
  Number(marketing.toFixed(2)), //kwota namarketing
  Number(sum.toFixed(2)),// kwota sumy od ktorej liczymy marketing
  Number(kwotaprowizji.toFixed(2)),//keota prowizji dla dostawcy od sprzedazy
    Number(kwotaDoObliczenia.toFixed(2))//kwota sumy licencji

];
};


export async function listManagmentMarketing() {
  try {
    const response = await fetch("https://hs2api.razamit.pl/approvedVendorsSummary", {
      credentials: 'include',
    });
    if (!response.ok) throw new Error(`Błąd: ${response.status}`);
    const data = await response.json();
    return data.approveVendors || [];
  } catch (err) {
    console.error("Błąd pobierania danych:", err);
    return [];
  }

}



